<div class="site-text">
    <p class="text">
        The following list is intended to help you find an answer or the right contact person for your concern as quickly as possible.
    </p>
    <p class="title">
        My organization is not listed in the directory.
    </p>
    <p class="text">
        eDirectory.ch lists companies and organizations domiciled in Switzerland that exchange electronic invoices with business partners via an e-invoicing service provider participating in eDirectory and that have granted this provider the right to publish their names in eDirectory. If you have any questions, please contact your e-invoicing service provider.
    </p>
    <p class="text">
        Invoice issuers who deliver electronic invoices to eBill recipients can be found using the corresponding eBill functions in the e-banking applications of Swiss banks. If you have any questions, please contact your eBill network partner.
        <br>
        For further information, see <a href="https://www.ebill.ch" target="_blank">www.ebill.ch</a>
    </p>
    <p div class="title">
        The details for my organization are incorrect.
    </p>
    <p class="text">
        Inform your e-invoicing service provider so that they can change the data.
    </p>
    <p class="title">
        I am an e-billing service provider who wants to list my customers in eDirectory.ch.
    </p>
    <p class="text">
        If you are an e-invoicing service provider offering e-billing services to companies and organizations domiciled in Switzerland and would like to publish your customers on eDirectory, please indicate your interest by contacting PostFinance <a href="mailto:billing-solutions@postfinance.ch?subject=eDirectory">(billing-solutions@postfinance.ch)</a>. We will get back to you as soon as possible.
    </p>
</div>
